import { create } from "zustand";

import type { Guide } from "./layout";

export const useGuideStore = create<{
  guides: Guide[];
  setGuides: (guides: Guide[]) => void;
}>((set) => ({
  guides: [],
  setGuides: (guides) =>
    set((s) => (s.guides.length === 0 && guides.length === 0 ? s : { guides })),
}));
